<template>
  <div class="d-flex justify-center flex-column">
    <v-btn
      type="button"
      min-width="150"
      :prepend-icon="shouldIconsDisplay ? props.prependIcon : ''"
      :append-icon="shouldIconsDisplay ? props.appendIcon : ''"
      color="primary"
      class="my-4"
      :disabled="props.loading">
      <span v-if="!props.loading"><slot></slot></span>
      <v-progress-circular
        size="small"
        v-else
        indeterminate
        :color="loadingColor"></v-progress-circular>
    </v-btn>
  </div>
</template>

<script lang="ts" setup>
/* global defineProps */

import { computed } from 'vue';

const props = defineProps({
  loading: {
    type: Boolean,
    required: false,
    default: false
  },
  prependIcon: {
    type: String,
    required: false
  },
  appendIcon: {
    type: String,
    required: false
  },
  loadingColor: {
    type: String,
    required: false,
    default: 'white'
  }
});

const shouldIconsDisplay = computed(() => {
  return !props.loading;
});
</script>
